import api from "./api";

export const dashboardService = {
  getLeaderboard: async (communityId = "", groupId = "") => {
    try {
      let query = "";
      if (communityId) {
        query += `?CommunityId=${communityId}`;
      }
      if (groupId) {
        query += query ? `&GroupId=${groupId}` : `?GroupId=${groupId}`;
      }

      const endpoint = query
        ? `/mapi/dashboard/countCommunityLeaderboard${query}`
        : `/mapi/dashboard/countAllLeaderboard`;

      const response = await api.get(endpoint);
      return response.data.Data || response.data; // Handle both response formats
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
      throw error;
    }
  },

  totalCommunities: async () => {
    try {
      const response = await api.get("/mapi/dashboard/totalCommunities");
      const total = response.data?.Data?.total_communities ?? 0;
      return [{ total }]; // return an array of object
    } catch (error) {
      console.error("Error fetching total communities:", error);
      throw error;
    }
  },

  totalUsers: async () => {
    try {
      const response = await api.get("/mapi/dashboard/totalUsers");
      const total = response.data?.Data?.total_users ?? 0;
      return [{ total }]; // return an array of object
    } catch (error) {
      console.error("Error fetching total users:", error);
      throw error;
    }
  },

  countRecycledMaterials: async (profileId = null) => {
    try {
      const config = {};

      // Only add ProfileId to params if it's provided
      if (profileId) {
        config.params = {
          ProfileId: profileId,
        };
      }

      const response = await api.get(
        "/mapi/dashboard/countRecycledMaterials",
        config
      );

      console.log(
        "Count recycled materials api response: ",
        response.data.Data
      );
      return response.data.Data;
    } catch (error) {
      console.error("Error fetching recycled materials:", error);
      throw error;
    }
  },

  countCommunityContributions: async (
    communityId = null,
    startDate = null,
    endDate = null
  ) => {
    try {
      const config = {
        params: {},
      };

      // Only add parameters if they are provided (not null)
      if (communityId) {
        config.params.CommunityId = communityId;
      }
      if (startDate) {
        config.params.StartDate = startDate;
      }
      if (endDate) {
        config.params.EndDate = endDate;
      }

      const response = await api.get(
        "/mapi/dashboard/countCommunityContributions",
        config
      );

      console.log(
        "Count community Contributions api response: ",
        response.data.Data
      );

      return response.data.Data;
    } catch (error) {
      console.error("Error fetching total countCommunityContributions:", error);
      throw error;
    }
  },

  countCommunityUsers: async (communityId = null) => {
    try {
      const config = {};

      if (communityId) {
        config.params = {
          CommunityId: communityId,
        };
      }

      const response = await api.get(
        "/mapi/dashboard/countCommunityUsers",
        config
      );

      // console.log("count comm ", response.data.Data);

      // Ensure we return an array with the response data
      return [response.data.Data];
    } catch (error) {
      console.error("Error fetching community users:", error);
      throw error;
    }
  },

  countUserPoints: async (entityId = null) => {
    try {
      const config = {};
      if (entityId) {
        config.params = {
          EntityId: entityId,
        };
      }
      const response = await api.get("/mapi/dashboard/countUserPoints", config);
      console.log("count user points ", response.data.Data);
      return response.data.Data; // Return the Data object directly, not wrapped in array
    } catch (error) {
      console.error("Error fetching users points:", error);
      throw error;
    }
  },

  countProfilePoints: async (entityId = null, profileId = null) => {
    try {
      const config = {
        params: {},
      };

      if (entityId) {
        config.params.EntityId = entityId;
      }

      if (profileId) {
        config.params.ProfileId = profileId;
      }

      const response = await api.get(
        "/mapi/dashboard/countProfilePoints",
        config
      );
      // console.log("count profile points ", response.data.Data);
      return response.data.Data; // Return the Data object directly, not wrapped in array
    } catch (error) {
      console.error("Error fetching users points:", error);
      throw error;
    }
  },

  totalPocs: async () => {
    try {
      const response = await api.get("/mapi/dashboard/totalPocs");
      const total = response.data?.Data?.total_pocs ?? 0;
      return [{ total }]; // return an array of object
    } catch (error) {
      console.error("Error fetching total POCs:", error);
      throw error;
    }
  },

  countRecycledItemsByDate: async (startDate, endDate) => {
    try {
      const response = await api.get(
        "/mapi/dashboard/countRecycledItemsByDate",
        {
          params: {
            StartDate: startDate,
            EndDate: endDate,
          },
        }
      );
      return response.data.Data; // returns an array of daily stats
    } catch (error) {
      console.error("Error fetching recycled items count by date:", error);
      throw error;
    }
  },

  countCommunities: async (startDate = null, endDate = null, status = "A") => {
    try {
      const config = {
        params: {},
      };

      // Add dates if provided
      if (startDate && endDate) {
        config.params.StartDate = startDate;
        config.params.EndDate = endDate;
      }

      // Add status if provided
      if (status) {
        config.params.Status = status;
      }

      const response = await api.get(
        "/mapi/dashboard/countCommunities",
        config
      );

      console.log("Community counts API response:", response.data.Data);
      return response.data.Data; // Return just the Data array from response
    } catch (error) {
      console.error("Error fetching community counts:", error);
      throw error;
    }
  },

  countProfileContributions: async (
    entityId = null,
    profileId = null,
    startDate = null,
    endDate = null
  ) => {
    try {
      const config = {
        params: {},
      };

      if (entityId) config.params.EntityId = entityId;
      if (profileId) config.params.ProfileId = profileId;
      if (startDate) config.params.StartDate = startDate;
      if (endDate) config.params.EndDate = endDate;

      const response = await api.get(
        "/mapi/dashboard/countProfileContributions",
        config
      );

      // console.log(
      //   "Count profile Contributions FULL api response: ",
      //   response.data
      // );

      return response.data; // Return the full response data object
    } catch (error) {
      console.error("Error fetching profile contributions:", error);
      throw error;
    }
  },

  countTotalPendingRequests: async (entityId = null) => {
    try {
      const config = {};
      if (entityId) {
        config.params = {
          EntityId: entityId,
          Status: "P",
        };
      }
      const response = await api.get(
        "/mapi/dashboard/countTotalPendingRequest",
        config
      );
      // console.log("count total pending requests ", response.data.Data);
      return response.data.Data; // Return the Data object directly, not wrapped in array
    } catch (error) {
      console.error("Error fetching total pending requests:", error);
      throw error;
    }
  },
};
